import { render, staticRenderFns } from "./DiagramPartsList.vue?vue&type=template&id=40b169bd"
import script from "./DiagramPartsList.ts?vue&type=script&lang=ts&external"
export * from "./DiagramPartsList.ts?vue&type=script&lang=ts&external"
import style0 from "./DiagramPartsList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports